import { render, staticRenderFns } from "./OperationsByProductCSide.vue?vue&type=template&id=322b8e9b"
import script from "./OperationsByProductCSide.vue?vue&type=script&lang=js"
export * from "./OperationsByProductCSide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports